import React from "react";
import { motion } from "motion/react";
import { Badge } from "../../ui/Badge";
import { ArrowRight } from "lucide-react";
import TypewriterText from "../../ui/TypewriterText";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section
      className="position-relative d-flex align-items-center justify-content-center overflow-hidden"
      style={{ minHeight: "100vh" }}
    >
      {/* Animated Background */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ zIndex: 0 }}
      >
        <div
          className="w-100 h-100"
          style={{
            background: "linear-gradient(135deg, #ebf8ff, #e0f2fe, #bfdbfe)",
            position: "relative",
          }}
        >
          {[...Array(6)].map((_, i) => {
            const left = Math.random() * 100;
            const top = Math.random() * 100;
            return (
              <motion.div
                key={i}
                className="position-absolute rounded-circle"
                style={{
                  width: "18rem",
                  height: "18rem",
                  background: "rgba(59,130,246,0.2)",
                  filter: "blur(3rem)",
                  left: `${left}%`,
                  top: `${top}%`,
                }}
                animate={{
                  x: [0, 100, 0],
                  y: [0, -100, 0],
                  scale: [1, 1.2, 1],
                }}
                transition={{
                  duration: 20 + i * 2,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              />
            );
          })}
        </div>
      </div>

      <div className="position-relative z-2 container text-center px-3">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mx-auto"
          style={{ maxWidth: "800px" }}
        >
          <Badge className="mb-4 mt-5 bg-primary text-white border-0">
            Premium Software Solutions
          </Badge>
          <h1 className="display-2 fw-bold mb-4">
            <TypewriterText
              texts={[
                "Building Digital Futures",
                "AI-Driven Solutions",
                "Innovative Software Development",
              ]}
              speed={100}
              pause={2000}
              className="text-primary"
            />
          </h1>
          <p className="lead text-secondary fw-500 mb-5">
            At MetaFox Tech, we don't just build software we engineer digital
            ecosystems that are scalable, intelligent, and designed to evolve
            with your business. From AI-powered platforms to custom web and
            mobile solutions, we turn bold ideas into high-impact products.
          </p>
          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Link
            to={"/contact"}
              size="sm"
              className="btn btn-primary btn-lg rounded-pill px-4"
            >
              Start Your Project <ArrowRight className="ms-2" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
